import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const Jobs: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Job Management
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Typography variant="body1">
          Job monitoring and management interface coming soon...
        </Typography>
      </Paper>
    </Box>
  );
};

export default Jobs;
